import { RowButton, Icon } from "../design";
import "./reportDrawer.css";

// Header row of a collapsible Card: content on the left, chevron on the right.
// `chevronTooltipId` puts a react-tooltip on the chevron (used when locked).
export const ReportToggle = ({
  open,
  onClick,
  locked = false,
  chevronTooltipId,
  children,
}) => (
  <RowButton
    type="button"
    className="reportDrawer__toggle"
    aria-expanded={open}
    aria-disabled={locked || undefined}
    onClick={onClick}
  >
    <span className="reportDrawer__toggle-main">{children}</span>
    <span className="reportDrawer__chevron" data-tooltip-id={chevronTooltipId}>
      <Icon name="chevronDown" size={18} className={open ? "is-open" : ""} />
    </span>
  </RowButton>
);

// Section heading inside a Card: icon, title and an optional (i) for a tooltip.
export const ReportSectionTitle = ({ icon, tooltipId, children }) => (
  <div className="reportDrawer__section-title">
    <Icon name={icon} size={18} />
    <h3 className="reportDrawer__heading">{children}</h3>
    {tooltipId && (
      <span className="reportDrawer__tip" data-tooltip-id={tooltipId}>
        <Icon name="info" size={16} />
      </span>
    )}
  </div>
);
